import React, { HTMLAttributes } from 'react'

export const MerifyMSvg = ({ className, ...props }: HTMLAttributes<HTMLOrSVGElement>) => {
	return (
		<svg
			viewBox='0 0 88 79'
			width='88'
			height='79'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`merify-m${className ? ` ${className}` : ''}`}
			{...props}
		>
			<path
				d='M31.432 7.78c-1.783 0-4.754.9-8.319.9-6.44 0-6.785-1.38-6.785-1.38 0-.479 1.668-1.667 2.377-1.667a2.55 2.55 0 01.537 0 10.6 10.6 0 002.913.421C30.473 6.054 37.144.88 43.028.88c5.002 0 6.785 2.204 6.785 5.348 0 6.842-8.568 18.15-11.251 21.083a.23.23 0 00.23.23c1.418 0 20.815-22.233 25.798-24.61a6.017 6.017 0 012.51-.651 3.47 3.47 0 012.914 1.36 13.014 13.014 0 013.623 7.667 6.057 6.057 0 01-1.016 3.277c-2.147 3.259-8.855 13.014-8.855 14.337 0 0 0 .115.115.115.709 0 2.683-2.147 2.683-2.147.46-.651 13.55-11.5 18.304-11.5a2.837 2.837 0 012.511 2.971 2.299 2.299 0 01-.594 1.668c-3.45 4.101-15.238 25.626-15.238 35.745a4.754 4.754 0 004.696 4.754 11.5 11.5 0 009.584-8.146s.479-.652.824-.652.843 1.131.843 1.668c0 5.117-14.106 24.725-29.555 24.725-5.232 0-8.932-2.913-8.932-9.22 0-4.388 1.917-10.464 6.134-18.361 0 0 5.942-11.308 6.114-12.554 0-.23-.115-.422-.288-.422-.43.075-.825.283-1.13.594-.307.48-9.871 12.67-12.957 14.989a9.585 9.585 0 01-6.134 2.089c-5.117 0-13.09-1.917-13.09-4.466a3.18 3.18 0 01.67-1.782c1.783-2.434 9.028-12.133 9.028-12.133 0-.652 0-1.13-.23-1.13s-.249 0-.422.248c-.766.767-14.144 14.912-16.655 16.35a15.448 15.448 0 01-6.843 1.916C7.742 54.24.42 48.106.42 43.41c0-.402.307-1.13 2.262-2.127 11.5-6.191 30.455-25.166 30.455-32.066-.096-1.074-.69-1.438-1.705-1.438z'
				fill='currentColor'
			/>
		</svg>
	)
}
